export const environment = {
  production: false,
  build: 'development',
  apiBaseUrl: 'https://staging-jobmatcher-api.eeeeee.be',
  authConfig: {
    // Url of the Identity Provider
    issuer: 'https://auth.mglsk.net',

    // URL of the SPA to redirect the user to after login
    // redirectUri: 'http://localhost:4200/auth/callback',
    // postLogoutRedirectUri: 'http://localhost:4200/auth/logout',
    redirectUri: 'https://jobmatcher.eeeeee.be/auth/callback',
    postLogoutRedirectUri: 'https://jobmatcher.eeeeee.be/auth/logout',

    // The SPA's id. The SPA is registerd with this id at the auth-server
    // clientId: 'server.code',
    clientId: '300147087419441154',

    // Just needed if your auth server demands a secret. In general, this
    // is a sign that the auth server is not configured with SPAs in mind
    // and it might not enforce further best practices vital for security
    // such applications.
    // dummyClientSecret: 'secret',

    responseType: 'code',

    // set the scope for the permissions the client should request
    // The first four are defined by OIDC.
    // Important: Request offline_access to get a refresh token
    // The api scope is a usecase specific one
    scope: 'openid profile email offline_access urn:zitadel:iam:org:project:id:299453472112115714:aud',
    oidc: true,

    showDebugInformation: true,
    requireHttps: false,
    requestAccessToken: true,
  },
};
